import React from "react";
import { observer } from "mobx-react";
import { FormProvider, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";

import classNames from "classnames";
import { CashoutStore } from "@state/stores/my-bets/CashoutStore";
import { CashoutLocation } from "@utils/common/cashoutLocation";
import { OpenCashoutModalType } from "@data-types/my-bets/OpenCashoutModal";

export default observer(function CashoutConfirmationForm(props: {
	store: CashoutStore;
}) {
	const { t } = useTranslation();

	const methods = useForm();

	const { register, handleSubmit } = methods;

	const onSubmit = (data: OpenCashoutModalType) => {
		if (props.store.cashoutModalData) {
			props.store.cashout(
				{
					id: props.store.cashoutModalData?.id,
					calculatedCashoutAmount:
						props.store.cashoutModalData?.calculatedCashoutAmount,
					displayedAmount:
						props.store.cashoutModalData.displayedAmount,
					userId: props.store.cashoutModalData.userId,
					cType: props.store.cashoutModalData?.cType,
					isLive: props.store.cashoutModalData?.isLive,
					isChangeAccepted: data.isChangeAccepted || false,
					liveBetSlipCountdown:
						props.store.cashoutModalData?.liveBetSlipCountdown,
				},
				CashoutLocation.OFFER
			);
		}
	};

	const checkFieldClasses = classNames("input--check u-mar--y--xsml");

	return (
		<>
			<FormProvider {...methods}>
				<form
					onSubmit={handleSubmit(onSubmit)}
					id="cashout-form"
				>
					<button
						className="bet__btn btn btn--wrap btn--wrap--base btn--block btn--success btn--icon"
						type="submit"
					>
						<i className="u-icon u-icon--sml u-icon--check u-color--core--snow"></i>
						<span>{t<string>("mybets:ITEM.CASHOUT")}</span>
					</button>
					<button
						className="bet__btn btn btn--wrap btn--wrap--base btn--block btn--primary--inverted btn--icon u-color--sent--danger"
						type="button"
						onClick={props.store.closeCashoutModal}
					>
						<i className="u-icon u-icon--sml u-icon--remove u-color--sent--danger" />
						<span>{t<string>("COMMON.CANCEL")}</span>
					</button>

					<div className={checkFieldClasses}>
						<input
							id="isChangeAccepted"
							className="input--check__box"
							type="checkbox"
							{...register("isChangeAccepted")}
						/>
						<label
							htmlFor="isChangeAccepted"
							className="input--check__label u-type--wgt--regular"
						>
							{t<string>("mybets:CASHOUT.ACCEPT_CHANGED_AMOUNT")}
						</label>
					</div>
				</form>
			</FormProvider>
		</>
	);
});
